if (!window.map)
    window.map = {};
if (!window.map.data)
    window.map.data = {};

export const daysOfWeek = [
    'Pondelok',
    'Utorok',
    'Streda',
    'Štvrtok',
    'Piatok',
    'Sobota',
    'Nedeľa',
];

export const centers = window.map.data.centers = [
    {
        id: 1,
        name: 'Bratislava'/*'Bratislava - regionálna kancelária'*/,
        address: 'Rožňavská 24, 821 04 Bratislava (2. poschodie)',
        email: 'obnovdom-ba@sazp.sk',
        phone: {text: '+421 907 188 858', href: 'tel:+421907188858'},
        opening_hours: [
            '8:00 - 16:00',
            '8:00 - 16:00',
            '8:00 - 16:00',
            '8:00 - 16:00',
            '8:00 - 16:00',
            'Zatvorené',
            'Zatvorené',
        ],
        navigate: 'https://goo.gl/maps/uPYPf6oUeYnf4ivo9',
        coordinates: [17.17042205274972, 48.18013155],
        image: '',
        additionalInfo: '',
    },
    {
        id: 2,
        name: 'Trenčín',
        address: 'Legionárska 7158/5, 911 01 Trenčín',
        email: 'obnovdom-tn@sazp.sk',
        phone: {text: '+421 907 207 069', href: 'tel:+421907207069'},
        opening_hours: [
            'Zatvorené',
            '10:00 - 16:00',
            'Zatvorené',
            '10:00 - 16:00',
            'Zatvorené',
            'Zatvorené',
            'Zatvorené',
        ],
        navigate: 'https://goo.gl/maps/P1vNsmzUy4y7MSJT9',
        coordinates: [18.0349803196307, 48.88711139012726],
        image: 'assets/images/map/Trencin.png',
        additionalInfo: '',
    },
    {
        id: 3,
        name: 'Lučenec',
        address: 'Vajanského 4, 984 01 Lučenec',
        email: 'obnovdom-lc@sazp.sk',
        phone: {text: '+421 907 182 661', href: 'tel:+421907182661'},
        opening_hours: [
            'Zatvorené',
            '10:00 - 16:00',
            'Zatvorené',
            '10:00 - 16:00',
            'Zatvorené',
            'Zatvorené',
            'Zatvorené',
        ],
        navigate: 'https://goo.gl/maps/yvjixJngtRQx6CF58',
        coordinates: [19.66917338398439, 48.32740266942457],
        image: 'assets/images/map/Lucenec.png',
        additionalInfo: '',
    },
    {
        id: 4,
        name: 'Žilina',
        address: 'Dolný Val 178/20, 010 01 Žilina',
        email: 'obnovdom-za@sazp.sk',
        phone: {text: '+421 907 180 136', href: 'tel:+421907180136'},
        opening_hours: [
            'Zatvorené',
            '10:00 - 16:00',
            'Zatvorené',
            '10:00 - 16:00',
            'Zatvorené',
            'Zatvorené',
            'Zatvorené',
        ],
        navigate: 'https://goo.gl/maps/nQ9KgNGohAAHCMug8',
        coordinates: [18.73841436249762, 49.22451672853244],
        image: 'assets/images/map/Zilina.png',
        additionalInfo: '',
    },
    {
        id: 5,
        name: 'Prešov',
        address: 'Levočská 6115/3, 080 01 Prešov',
        email: 'obnovdom-po@sazp.sk',
        phone: {text: '+421 907 207 172', href: 'tel:+421907207172'},
        opening_hours: [
            'Zatvorené',
            '10:00 - 16:00',
            'Zatvorené',
            '10:00 - 16:00',
            'Zatvorené',
            'Zatvorené',
            'Zatvorené',
        ],
        navigate: 'https://goo.gl/maps/GZ9ep9RFw4cksfzc6',
        coordinates: [21.238292485205594, 49.001227763577916],
        image: 'assets/images/map/Presov.png',
        additionalInfo: '',
    },
    {
        id: 6,
        name: 'Košice',
        address: 'Alžbetina 25, 040 01 Košice',
        email: 'obnovdom-ke@sazp.sk',
        phone: {text: '+421 907 188 287', href: 'tel:+421907188287'},
        opening_hours: [
            'Zatvorené',
            '10:00 - 16:00',
            'Zatvorené',
            '10:00 - 16:00',
            'Zatvorené',
            'Zatvorené',
            'Zatvorené',
        ],
        navigate: 'https://goo.gl/maps/dTBBwiM8DATEeNau7',
        coordinates: [21.2553271123065, 48.719825000441624],
        image: 'assets/images/map/rk-ke-082024.png',
        additionalInfo: '',
    },
    {
        id: 7,
        name: 'Liptovský Mikuláš',
        address: 'Ester Šimerovej Martinčekovej 4505/2, 031 01 Liptovský Mikuláš',
        email: 'obnovdom-lm@sazp.sk',
        phone: {text: '+421 907 205 147', href: 'tel:+421907205147'},
        opening_hours: [
            'Zatvorené',
            '10:00 - 16:00',
            'Zatvorené',
            '10:00 - 16:00',
            'Zatvorené',
            'Zatvorené',
            'Zatvorené',
        ],
        navigate: 'https://goo.gl/maps/GbEFsmMLaiRv6skF6',
        coordinates: [19.60860108455084, 49.084807239558316],
        image: 'assets/images/map/Liptovsky-Mikulas.png',
        additionalInfo: '',
    },
    {
        id: 8,
        name: 'Nitra',
        address: 'Farská 7, 949 01 Nitra',
        email: 'obnovdom-nr@sazp.sk',
        phone: {text: '+421 907 200 034', href: 'tel:+421907200034'},
        opening_hours: [
            'Zatvorené',
            '10:00 - 16:00',
            'Zatvorené',
            '10:00 - 16:00',
            'Zatvorené',
            'Zatvorené',
            'Zatvorené',
        ],
        navigate: 'https://goo.gl/maps/utUiB39CbfXe6XGU7',
        coordinates: [18.08563360863563, 48.314207529979505],
        image: 'assets/images/map/Nitra.png',
        additionalInfo: '',
    },
    {
        id: 9,
        name: 'Banská Bystrica',
        address: 'Kuzmányho 330/5, 974 01 Banská Bystrica',
        email: 'obnovdom-bb@sazp.sk',
        phone: {text: '+421 915 595 042', href: 'tel:+421915595042'},
        opening_hours: [
            'Zatvorené',
            '10:00 - 16:00',
            'Zatvorené',
            '10:00 - 16:00',
            'Zatvorené',
            'Zatvorené',
            'Zatvorené',
        ],
        navigate: 'https://goo.gl/maps/in23pT1HbW5JZG8PA',
        coordinates: [19.143969686507514, 48.732784947129375],
        image: 'assets/images/map/Banska-Bystrica.png',
        additionalInfo: '',
    },
    {
        id: 10,
        name: 'Trnava',
        address: 'Bratislavská 28, 917 01 Trnava (budova SVP)',
        email: 'obnovdom-tt@sazp.sk',
        phone: {text: '+421 907 200 635', href: 'tel:+421907200635'},
        opening_hours: [
            'Zatvorené',
            '10:00 - 16:00',
            'Zatvorené',
            '10:00 - 16:00',
            'Zatvorené',
            'Zatvorené',
            'Zatvorené',
        ],
        navigate: 'https://goo.gl/maps/9wG33op44XcGFLdQ6',
        coordinates: [17.61673048167291, 48.37374443735073],
        image: 'assets/images/map/Trnava-2023.png',
        additionalInfo: '',
    },
];
